import { provideComponent, ContentTag, WidgetTag } from 'scrivito'

import { TextTableWidget } from './TextTableWidgetClass'
import { alignmentClassName } from '../../utils/alignmentClassName'

provideComponent(TextTableWidget, ({ widget }) => (
  <WidgetTag tag="td">
    <ContentTag
      attribute="text"
      className={alignmentClassName(widget.get('alignment'))}
      content={widget}
      tag="p"
    />
  </WidgetTag>
))
